const defaultLocale = 'zh';

export function getLocale(language) {
  if (!language) return defaultLocale;
  switch (language) {
    case 'zh-Hant':
      return 'zh';
    default:
      return language;
  }
}

export function getLanguage(locale) {
  return (
    ['ZH_HANT', 'ZH_HANS', 'PT', 'EN'][['zh-Hant', 'zh-Hans', 'pt', 'en'].indexOf(locale)] ||
    'ZH_HANT'
  );
}

export function getLanguageText(obj, key = 'name', language) {
  if (!obj) return '';

  const locale = ['ZhHant', 'Pt', 'En'][['zh', 'pt', 'en'].indexOf(language)] || 'ZhHant';
  return obj[`${key}${locale}`];
}

export function getLanguageText2(obj, key = 'name', language) {
  if (!obj) return '';

  const locale = ['Cn', 'Pt', 'En'][['zh', 'pt', 'en'].indexOf(language)] || 'Cn';
  return obj[`${key}${locale}`];
}

export function getLanguageText3(obj, key = 'name', language) {
  if (!obj) return '';

  const locale = ['Tc', 'Pt', 'En'][['zh', 'pt', 'en'].indexOf(language)] || 'Tc';
  return obj[`${key}${locale}`];
}

export function getLanguageText4(obj, key = 'name', language) {
  if (!obj) return '';

  const locale = ['Hant', 'Pt', 'En'][['zh', 'pt', 'en'].indexOf(language)] || 'Hant';
  return obj[`${key}${locale}`];
}
